// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3KOnh","errors":"Errors_errors__2ZfON"};